
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signupUser } from "../../lib/AuthApi";
import { getClasses } from "../../lib/ClassApi";
import PasswordInput from "./components/PasswordInput";
import Logo from "../../components/common/Logo";

const RegisterUser = () => {
  const navigate = useNavigate();

  const [classList, setClassList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const initialFormState = {
    username: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    birthDate: "",
    schoolName: 11,
    medium: "",
    state: "",
    city: "",
    className: "",
    board: "",
    Sections: "",
  };

  const [form, setForm] = useState(initialFormState);

  // ================= Fetch Classes =================

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const res = await getClasses();

        if (res.success && Array.isArray(res.data)) {
          setClassList(res.data);
        }
      } catch (err) {
        console.log("Class API error:", err);
      }
    };

    fetchClasses();
  }, []);

  // ================= Handle Change =================

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // ================= Handle Signup =================

  const handleSignUp = async (e) => {
    e.preventDefault();

    if (!form.username || !form.password) {
      return setError("All fields are required");
    }

    if (form.password !== form.confirmPassword) {
      return setError("Passwords do not match");
    }

    const payload = {
      username: form.username,
      password: form.password,
      confirmPassword: form.confirmPassword,
      firstName: form.firstName,
      lastName: form.lastName,
      email: form.email,
      mobileNumber: form.mobile,
      CityName: form.city,
      StateName: form.state,
      dateOfBirth: form.birthDate,
      schoolId: 11,
      //Number(form.schoolName),
      RoleId: 3,
      UserRoles: ["student"],

      classSections: [
        {
          classId: Number(form.className),
          sections: [Number(form.Sections)],
          status: "A",
        },
      ],

      IsActive: true,
      ModifiedBy: 13,
    };

    try {
      setLoading(true);
      setError("");
      setSuccess("");

      const res = await signupUser(payload);


      if (!res?.data?.isSuccess) {
        setError(res?.data?.displayMessage || "Signup failed");
        return;
      }

      setSuccess(res?.data?.displayMessage ||"Your account has been created successfully");

      setForm(initialFormState);

      setTimeout(() => {
        navigate("/login");
      }, 1500);

    } catch (err) {
      console.log(err);

      setError(
        err?.response?.data?.message ||
        err?.message ||
        "Signup failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary flex flex-col items-center px-4 py-6">

      <Logo />

      <div className="w-full max-w-5xl mt-8">

        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold">
            Sign Up
          </h2>

          <p className="text-sm">
            Already have an account?{" "}
            <Link
              to="/login"
              className="text-primary"
            >
              Login
            </Link>
          </p>
        </div>

        {/* Success */}
        {success && (
          <p className="text-green-600 text-sm mb-4 font-medium">
            {success}
          </p>
        )}

        {/* Error */}
        {error && (
          <p className="text-red-500 text-sm mb-4">
            {error}
          </p>
        )}

        {/* Form */}
        <form
          onSubmit={handleSignUp}
          className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4"
        >

          {/* LEFT */}
          <div className="space-y-4">

            <input
              type="text"
              placeholder="Username / Email / Mobile*"
              value={form.username}
              onChange={(e) =>
                handleChange("username", e.target.value)
              }
              className="input"
            />

            <PasswordInput
              value={form.password}
              onChange={(e) =>
                handleChange("password", e.target.value)
              }
              placeholder="Password*"
            />

            <PasswordInput
              value={form.confirmPassword}
              onChange={(e) =>
                handleChange(
                  "confirmPassword",
                  e.target.value
                )
              }
              placeholder="Re-type Password*"
            />

            {/* <input
              type="text"
              placeholder="School name"
              value={form.schoolName}
              onChange={(e) =>
                handleChange("schoolName", e.target.value)
              }
              className="input"
            /> */}

            <select
              value={form.medium}
              onChange={(e) =>
                handleChange("medium", e.target.value)
              }
              className="input"
            >
              <option value="">Medium*</option>
              <option value="English">English</option>
              <option value="Hindi">Hindi</option>
            </select>

            <select
              value={form.state}
              onChange={(e) =>
                handleChange("state", e.target.value)
              }
              className="input"
            >
              <option value="">State*</option>
              <option value="Delhi">Delhi</option>
            </select>

            <select
              value={form.city}
              onChange={(e) =>
                handleChange("city", e.target.value)
              }
              className="input"
            >
              <option value="">City*</option>
              <option value="Delhi">Delhi</option>
            </select>
          </div>

          {/* RIGHT */}
          <div className="space-y-4">

            <input
              type="text"
              placeholder="First name*"
              value={form.firstName}
              onChange={(e) =>
                handleChange("firstName", e.target.value)
              }
              className="input"
            />

            <input
              type="text"
              placeholder="Last name*"
              value={form.lastName}
              onChange={(e) =>
                handleChange("lastName", e.target.value)
              }
              className="input"
            />

            <input
              type="text"
              placeholder="Mobile no.*"
              value={form.mobile}
              onChange={(e) =>
                handleChange("mobile", e.target.value)
              }
              className="input"
            />

            <input
              type="email"
              placeholder="Email ID*"
              value={form.email}
              onChange={(e) =>
                handleChange("email", e.target.value)
              }
              className="input"
            />

            <input
              type="date"
              value={form.birthDate}
              onChange={(e) =>
                handleChange("birthDate", e.target.value)
              }
              className="input"
            />

            <select
              value={form.className}
              onChange={(e) =>
                handleChange("className", e.target.value)
              }
              className="input"
            >
              <option value="">Class*</option>

              {classList.map((cls) => (
                <option
                  key={cls.id}
                  value={cls.id}
                >
                  {cls.classname}
                </option>
              ))}
            </select>

            <select
              value={form.Sections}
              onChange={(e) =>
                handleChange("Sections", e.target.value)
              }
              className="input"
            >
              <option value="">Section*</option>
              <option value="36">A</option>
            </select>
          </div>

          {/* Submit */}
          <div className="col-span-2">
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full disabled:opacity-60"
            >
              {loading ? "Creating..." : "Sign Up"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterUser;